import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "LoginPage" };
const _hoisted_2 = { class: "LoginPage-content" };
const _hoisted_3 = { class: "LoginPage-after text-gray-800 font-subtext" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoginHeader = _resolveComponent("LoginHeader");
    const _component_RouterView = _resolveComponent("RouterView");
    const _component_MobileAppsLogos = _resolveComponent("MobileAppsLogos");
    const _component_LanguageDropdown = _resolveComponent("LanguageDropdown");
    const _component_AtFooter = _resolveComponent("AtFooter");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoginHeader),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_RouterView),
            (_ctx.isMobileScreen)
                ? (_openBlock(), _createBlock(_component_MobileAppsLogos, {
                    key: 0,
                    class: "block-end-07"
                }))
                : _createCommentVNode("", true),
            _createVNode(_component_AtFooter, {
                class: "LoginPage-footer",
                links: _ctx.links
            }, {
                beforeLinks: _withCtx(() => [
                    _createVNode(_component_LanguageDropdown)
                ]),
                afterLinks: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.copyrightText), 1)
                ]),
                _: 1
            }, 8, ["links"])
        ])
    ]));
}
